export default __webpack_public_path__ + "static/media/learose-480w.c3b74a8a.avif";